<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-col cols="12">
      <v-table-pro-patient-list
        :headers="schema.headersCrud"
        :dataCrud="dataCrud"
        :clickTo="clickTo"
        :dialogAccountPin="schema.dialogAccountPin"
      />
    </v-col>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VTableProPatientList from '@/components/base/VTableProPatientList.vue';

export default {
  name: 'ProPatientsBPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VTableProPatientList,
  },
  data() {
    return {};
  },
 
  mounted() {
    this.loadSchema();
    this.loadDataCrud();
  },
  computed: {
    ...mapGetters('proPatientsBPage', ['schema', 'dataCrud']),
  },
  methods: {
    ...mapActions('proPatientsBPage', ['loadSchema', 'loadDataCrud']),

    clickTo(clickItem) {
      this.$store.commit('auth/setPatientsId', clickItem.patients_id);
      this.$router.push({ name: 'patients-c' });
    },
  },
};
</script>
